import Swiper, {Navigation, Scrollbar} from 'swiper';

const equalizersRegistry = new WeakMap();
const equalizedSelectors = [
    '.move-forward-sec__card-label',
    '.move-forward-sec__card-title',
];

const getMoveForwardSlides = (swiperEl) => {
    return Array.from(
        swiperEl.querySelectorAll('.swiper-wrapper > .swiper-slide')
    );
};

const getMoveForwardEqualizerGroups = (swiperEl) => {
    const slides = getMoveForwardSlides(swiperEl);
    const groups = [];

    equalizedSelectors.forEach((selector) => {
        const elements = slides
            .map((slide) => slide.querySelector(selector))
            .filter(Boolean);

        if (elements.length) {
            groups.push(elements);
        }
    });

    return groups;
};

const setupMoveForwardEqualizer = (swiperEl) => {
    const equalizer = equalizersRegistry.get(swiperEl);

    if (equalizer) {
        equalizer.refresh();
        return;
    }

    if (typeof window.lineTitlesFunc !== 'function') {
        return;
    }

    equalizersRegistry.set(
        swiperEl,
        window.lineTitlesFunc([], {
            getGroups: () => getMoveForwardEqualizerGroups(swiperEl),
        })
    );
};

const initMoveForwardSwiper = (scope = document) => {
    const wrappers = scope.querySelectorAll('.move-forward-swiper-wr');

    wrappers.forEach((wrapper) => {
        const swiperEl = wrapper.querySelector('.swiper');

        if (!swiperEl) {
            return;
        }

        if (swiperEl.swiper) {
            setupMoveForwardEqualizer(swiperEl);
            return;
        }

        const slidesCount = getMoveForwardSlides(swiperEl).length;

        if (!slidesCount) {
            return;
        }

        const scrollbarEl = wrapper.querySelector('.swiper-scrollbar');
        const nextEl = wrapper.querySelector('.swiper-button-next');
        const prevEl = wrapper.querySelector('.swiper-button-prev');

        new Swiper(swiperEl, {
            modules: [Navigation, Scrollbar],
            observer: true,
            observeParents: true,
            slidesPerView: 'auto',
            spaceBetween: 18,
            threshold: 10,
            watchOverflow: true,
            scrollbar: scrollbarEl ? {
                el: scrollbarEl,
                draggable: true,
                dragSize: 'auto',
            } : undefined,
            navigation: nextEl && prevEl ? {nextEl, prevEl} : undefined,
            breakpoints: {
                641: {
                    spaceBetween: 32,
                },
            },
        });

        setupMoveForwardEqualizer(swiperEl);
    });
};

initMoveForwardSwiper();
window.initMoveForwardSwiper = initMoveForwardSwiper;
